import React, { useState, useEffect } from "react";
import CloseIcon from '@mui/icons-material/Close';
import FoldersDisplay from './FoldersDisplay';

export default function PagesManager({ pages = [], skins = [], currentUser, breadcrumbs, target, setTarget, addNew, edit }) {
    const parent = breadcrumbs[breadcrumbs.length - 1];
    console.log(skins);
    const defaultSkin =
        parent?.skinId
            ? parent.skinId
            : skins
                .filter(s => s.type === "skin")
                .sort((a, b) => a.id - b.id)[0]?.id ?? null;

    const [input, setInput] = useState({
        title: "",
        type: "page",
        skinId: defaultSkin,
        isPrivate: parent?.isPrivate === 1 ? 1 : 0,
        order: 0
    });

    useEffect(() => {
        if (target.method === "edit") {
            setInput( {
                title: target.editingItem.title,
                type: target.editingItem.type,
                skinId: target.editingItem.skinId,
                isPrivate: target.editingItem.isPrivate,
                order: target.editingItem.order
            })
        }
    }, [target])


    function handleClose() {
        if (target.method === "edit") {
            setTarget(prev => {
                return {
                    ...prev,
                    method: null,
                    editingItem: null
                };
            });
            setInput({title: "", type: "page", skinId: 1, isPrivate: false});
        } else if (target.method === "create") {
            setTarget((prev) => ({...prev, method : null}));
            setInput({title: "", type: "page", skinId: 1, isPrivate: false});
        }
    }

    function handleChange(event) {
        const { name, value, type, checked } = event.target;
        setInput(prevInput => ({
            ...prevInput,
            [name]: type === "checkbox"? (checked ? 1 : 0) : value
        }));
    }

    function findChildrenAtPath(items, path) {
        let current = items;

        for (const folderId of path) {
            const folder = current.find(item => (item.type === "folder" || item.type === "skinFolder") && item.id === folderId);
            if (!folder) return [];
            current = folder.children || [];
        }

        return current;
    }

    function submit() {
        if (input.title.length === 0) return;

        if (target.method === "create") {
            const parentId = target.path.length > 0
            ? target.path[target.path.length - 1]
            : null;

            const containerItems = findChildrenAtPath(pages, target.path);
            const order = containerItems.length;

            const newItem = {
            type: input.type,
            title: input.title,
            skinId: input.skinId,
            isPrivate: input.isPrivate,
            order,
            parentId
            };

            addNew(newItem);
            setInput({ title: "", type: "page", skinId: 1, isPrivate: false });
            setTarget(prev => ({ ...prev, method: null }));
        }

        if (target.method === "edit") {
            const newItem = {
            id: target.editingItem.id,
            type: input.type,
            title: input.title,
            skinId: input.skinId,
            isPrivate: input.isPrivate,
            order: input.order
            };
            edit(newItem);
            setInput({ title: "", type: "page", skinId: 1, isPrivate: false });
            setTarget(prev => ({ ...prev, method: null, editingItem: null }));
        }
    }

    return (
        <div id="folder-create-container">
            <CloseIcon className="manager-create-close" onClick={handleClose}/>
            <div id="folder-create">
                <input
                    name="title"
                    onChange={handleChange}
                    value={input.title}
                    placeholder="title"
                    readOnly={target.method === "edit" && target.editingItem.type === "page" && target.editingItem.isProfile === 1? true: false}
                />
                {target.method === "create" && 
                    <select name="type" onChange={handleChange} value={input.type} >
                        <option value="page">page</option>
                        <option value="folder">folder</option>
                    </select>
                }
                <div id="skin-id-select">
                    <div>
                        <p>{input.type === "page" ? "skin select" : "default skin select (this can be overridden in individual pages)"}</p>
                        <FoldersDisplay 
                            currentlyViewing={skins} 
                            currentUser={currentUser}
                            input={input} 
                            setInput={setInput} 
                            type="skin-select"
                            total={skins}
                        />
                    </div>
                </div>
                <label className="folder-checkbox">private?
                    <input type="checkbox" 
                        name="isPrivate" 
                        onChange={handleChange}
                        checked={input.isPrivate === 1}
                        disabled={
                            ((target.method === "create" || target.method === "edit") && breadcrumbs.length > 0 && breadcrumbs[breadcrumbs.length - 1]?.isPrivate === 1) ||
                            (target.method === "edit" && target.editingItem === "page" && target.editingItem.isProfile === 1) ||
                            false // Default fallback to ensure no errors
                          }
                    />
                    <span className="checkmark" style={{marginLeft: 0, top: 0, marginRight: "10px"}}></span>
                </label>
                <button id="folder-submit-button" className="settings-button" onClick={submit}>submit</button>
            </div>
        </div>
    )
}